module App.Classes {
    export interface IStore {
        name: string
        id: number
        waitingAllowed: boolean
        isVisible: boolean
        excludeForTyreChange: boolean
        alwaysAllowPickup: boolean
    }

    export class Store implements IStore {
        name: string
        id: number
        waitingAllowed: boolean
        isVisible: boolean
        excludeForTyreChange: boolean
        alwaysAllowPickup: boolean
    }
}